export type Merge<T, U> = { [P in keyof (T & U)]: (T & U)[P] };
export type OptionalKeys<T, K extends keyof T> = Merge<Omit<T, K>, { [P in K]?: T[P] }>;
export type RequiredKeys<T, K extends keyof T> = Merge<Omit<T, K>, { [P in K]-?: T[P] }>;
